import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import {
  Users,
  CalendarCheck,
  HeartPulse,
  Package,
  MapPin,
  Clipboard
} from "lucide-react";

import { useConfig } from "../../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../../utils/AxiosInstance.jsx";
import FilterContext from '../../utils/FilterContext';

export const App = () => {

  const { API_BASE_URL } = useConfig(); // ✅ from context
  const AxiosInstance = createAxiosInstance(API_BASE_URL);

  const [states, setStates] = useState([]);        // From /center/own
  const [widgets, setWidgets] = useState({});      // State-wise widget data
  const [loading, setLoading] = useState({});      // State-wise loader flag

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  const previousDay = currentDate.toISOString().split("T")[0];


  // Access filter data and setter function from context
  const { filters, setFilters } = useContext(FilterContext);
  const filtersRef = useRef(filters);
  const [rawStart, rawEnd] = filters?.dateRange?.split(" - ") ?? [];

  const startDate = rawStart?.trim() || previousDay;
  const endDate = rawEnd?.trim() || previousDay;

  // const startDate = previousDay;
  // const endDate = previousDay;

  const stateOrderMap = {
    "Uttarakhand": 0,
    "West Bengal": 1,
    "Maharashtra": 2,
    "Karnataka": 3,
    "Tamil Nadu": 4,
    "Madhya Pradesh": 5,
    "New Delhi": 6,
  };

  // Fetch all states first
  useEffect(() => {
    if (!filters) return; // Guard against null filters

    if (!filtersRef.current || filtersRef.current !== filters) {
      filtersRef.current = filters;
      fetchStates();
    }

  }, [filters]);

  const fetchStates = async () => {
    try {
      const res = await AxiosInstance.get("/centers/own");

      // Sort by custom order
      const stateList = (res.data.data || []).sort((a, b) => {
        return (stateOrderMap[a.hm_state] ?? 999) - (stateOrderMap[b.hm_state] ?? 999);
      });

      setStates(stateList);

      // Create loader for each state
      const loaderObject = {};
      stateList.forEach((st) => {
        loaderObject[st.hm_state] = true;
      });
      setLoading(loaderObject);

      // Fetch widgets for each state
      stateList.forEach((st) => fetchWidgetData(st.hm_state));
    } catch (error) {
      console.error("Error loading states", error);
    }
  };

  const fetchWidgetData = async (stateName) => {
    try {
      const res = await AxiosInstance.post("/dashboard/widget_details", {
        hm_state: stateName,
        startdate: startDate,
        enddate: endDate,
      });

      setWidgets((prev) => ({
        ...prev,
        [stateName]: res.data.data,
      }));

      setLoading((prev) => ({
        ...prev,
        [stateName]: false,
      }));
    } catch (err) {
      console.log("Error loading widget", err);

      setLoading((prev) => ({
        ...prev,
        [stateName]: false,
      }));
    }
  };

  return (
    <div className="" style={{ "paddingBottom": "100px" }}>
      <div className="row gy-3 pb-4">
        <div className="px-1" style={{ maxWidth: 'fit-content' }}>
          <div
            className="rounded-4 shadow-lg border"
            style={{
              background: "rgba(255,255,255,0.92)",
              backdropFilter: "blur(10px)",
            }}
          >
            {/* Header */}
            <div
              className="p-3 text-white rounded-top-4"
              style={{
                background:
                  "linear-gradient(135deg, #4f46e5 0%, #6366f1 50%, #818cf8 100%)",
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle me-3"
                  style={{
                    width: "35px",
                    height: "35px",
                    background: "rgba(255,255,255,0.2)",
                  }}
                >
                  <MapPin size={20} />
                </div>

                <span className="mb-0 fw-bold" style={{fontSize:"22px"}}>Details</span>
              </div>
            </div>



            {/* Data */}
            <div className="p-3">
              <div

                className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                style={{
                  background: "white",
                  cursor: "pointer",
                  transition: "0.3s",
                  columnGap: "10px"
                }}
              >
                {/* Left */}
                <div className='d-flex align-items-center' >
                  
                  <span className="fw-bold mb-0" style={{ fontSize: "18px" }}>Leads</span>
                </div>



              </div>

              <div

                className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                style={{
                  background: "white",
                  cursor: "pointer",
                  transition: "0.3s",
                  columnGap: "10px"
                }}
              >
                {/* Left */}
                <div className='d-flex align-items-center' >
                  
                  <span className="fw-bold mb-0" style={{ fontSize: "18px" }}>Appointments</span>
                </div>
              </div>
              <div

                className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                style={{
                  background: "white",
                  cursor: "pointer",
                  transition: "0.3s",
                  columnGap: "10px"
                }}
              >
                {/* Left */}
                <div className='d-flex align-items-center' >
                  
                  <span className="fw-bold mb-0" style={{ fontSize: "18px" }}>Patient New</span>
                </div>
              </div>
              <div

                className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                style={{
                  background: "white",
                  cursor: "pointer",
                  transition: "0.3s",
                  columnGap: "10px"
                }}
              >
                {/* Left */}
                <div className='d-flex align-items-center' >
                  
                  <span className="fw-bold mb-0" style={{ fontSize: "18px" }}>Patients Running</span>
                </div>
              </div>
              <div

                className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                style={{
                  background: "white",
                  cursor: "pointer",
                  transition: "0.3s",
                  columnGap: "10px"
                }}
              >
                {/* Left */}
                <div className='d-flex align-items-center' >
                  
                  <span className="fw-bold mb-0" style={{ fontSize: "18px" }}>Patients Treated</span>
                </div>
              </div>
              
            </div>

          </div>
        </div>
        {states.map((st, index) => {
          const CENTER_NAME = st.hm_state;
          const widget = widgets[CENTER_NAME];

          return (
            <div className="px-1" key={index} style={{ maxWidth: 'fit-content' }}>
              <div
                className="rounded-4 shadow-lg border"
                style={{
                  background: "rgba(255,255,255,0.92)",
                  backdropFilter: "blur(10px)",
                }}
              >
                {/* Header */}
                <div
                  className="p-3 text-white rounded-top-4"
                  style={{
                    background:
                      "linear-gradient(135deg, #4f46e5 0%, #6366f1 50%, #818cf8 100%)",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center rounded-circle me-3"
                      style={{
                        width: "35px",
                        height: "35px",
                        background: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <MapPin size={20} />
                    </div>

                    <span className="mb-0 fw-bold" style={{fontSize:"20px"}}>{CENTER_NAME}</span>
                  </div>
                </div>

                {/* Loader */}
                {loading[CENTER_NAME] && (
                  <div className="p-4 text-center">
                    <div className="spinner-border text-primary"></div>
                    <p className="mt-2 mb-0 fw-bold">Loading...</p>
                  </div>
                )}

                {/* Data */}
                {!loading[CENTER_NAME] && widget && (
                  <div className="p-3">
                    {[
                      {
                        title: "Leads",
                        value: widget.total_leads,
                        icon: Users,
                        color: "#0d6efd",
                      },
                      {
                        title: "Appointments",
                        value: widget.completed_appointments,
                        icon: CalendarCheck,
                        color: "#198754",
                      },
                      {
                        title: "Patients New",
                        value: widget.booked_package_patients,
                        icon: HeartPulse,
                        color: "#dc3545",
                      },
                      {
                        title: "Patients Running",
                        value: widget.running_package_patients,
                        icon: Package,
                        color: "#6f42c1",
                      },
                      {
                        title: "Patients Treated",
                        value: widget.treated_patients,
                        icon: Clipboard,
                        color: "#6f42c1",
                      },
                    ].map((m, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-3 shadow-sm"
                        style={{
                          background: "white",
                          cursor: "pointer",
                          transition: "0.3s",
                          columnGap: "10px"
                        }}
                      >
                        {/* Left */}
                        <div className='d-flex align-items-center' >
                          {/* <div
                            className="rounded-circle d-flex justify-content-center align-items-center me-3"
                            style={{
                              width: "40px",
                              height: "40px",
                              background: m.color,
                              color: "white",
                            }}
                          >
                            <m.icon size={22} />
                          </div>
                          <span className="fw-bold mb-0" style={{ fontSize: "22px" }}>{m.title}</span> */}
                        </div>

                        <span className="fw-bold" style={{ fontSize: "18px", color: m.color }}>
                          {m.value ?? 0}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

    </div>


  );
};

export default App;


